export const iconFontAwesomeChildhoodSnowman = (
	<i className="fa-solid fa-snowman"></i>
);
